'use strict';

(function (global) {

  /**
   * Колнтрол пагинации тулбара предпросмотра.
   *
   * @namespace window.Core.preview.toolbar
   * @since 5.7.0
   */
  class PaginationToolbarControl extends global.ToolbarControl {

    /**
     * Обновляет счётчик количества страниц документа.
     *
     * @method updatePageCount
     * @param {number} pageCount Общее количество страниц документа.
     */
    updatePageCount(pageCount) {
      this._jControl.find('.page-count').text(`/ ${pageCount}`);
    }
  }

  global.PaginationToolbarControl = PaginationToolbarControl;

})(window.Core.preview.toolbar);